import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { sendViewRoadmapScreenAnalyticsEvent } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/analytics';
import { setStickyHeaderScroll } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/roadmap';
import { reportTimeToInteractive } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/time-to-interactive';
import type { ReportTimeToInteractivePayload } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/time-to-interactive/types';
import {
	suspend,
	resume,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/enhancers/suspender';
import { updateColumnWidths } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/section-widths/actions';
import type { UpdateColumnWidthsActionPayload } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/section-widths/types';
import type { MapDispatchToPropsSimple } from '@atlassian/jira-portfolio-3-portfolio/src/common/types/redux';
import type { DispatchProps } from './types';

const mapDispatchToProps: MapDispatchToPropsSimple<DispatchProps> = (dispatch) => ({
	onRoadmapView: (analyticsEvent: UIAnalyticsEvent) => {
		dispatch(sendViewRoadmapScreenAnalyticsEvent(analyticsEvent));
	},
	onDragStart: () => {
		dispatch(suspend());
	},
	onDragEnd: () => {
		dispatch(resume());
	},
	setStickyHeaderScroll: (scrollTop: number) => {
		dispatch(setStickyHeaderScroll({ scrollTop }));
	},
	reportTimeToInteractive: (payload: ReportTimeToInteractivePayload) =>
		dispatch(reportTimeToInteractive(payload)),
	updateTopLevelColumnWidths: (payload: UpdateColumnWidthsActionPayload) =>
		dispatch(updateColumnWidths(payload)),
});

export default mapDispatchToProps;
